module.exports = __webpack_public_path__ + "img/lowerhand.fcda1304.svg";